import { PageWrapper } from 'layout/PublicLayout/Wrappers';
import View from './View';
import { Suspense } from 'react';

export const PublicAthletesView = () => {
    return (
        <PageWrapper>
            <Suspense fallback={<div>Loading...</div>}>
                <View />
            </Suspense>
        </PageWrapper>
    );
};
